import React from "react";

function KPIRenderer({ kpi }) {

    if (!kpi) {

        return null;

    }

    return (

        <div

            style={{

                display: "inline-block",

                minWidth: 220,

                marginTop: 10,

                marginBottom: 20,

                padding: 20,

                borderRadius: 10,

                border: "1px solid #dbe3ef",

                background: "#ffffff",

                boxShadow: "0 2px 8px rgba(0,0,0,0.08)"

            }}

        >

            <div

                style={{

                    fontSize: 13,

                    color: "#666",

                    marginBottom: 8

                }}

            >

                {kpi.title || "Metric"}

            </div>

            <div

                style={{

                    fontSize: 36,

                    fontWeight: "bold",

                    color: "#1565c0"

                }}

            >

                {kpi.value}

            </div>

            {

                kpi.subtitle &&

                (

                    <div

                        style={{

                            marginTop: 10,

                            fontSize: 13,

                            color: "#777"

                        }}

                    >

                        {kpi.subtitle}

                    </div>

                )

            }

        </div>

    );

}

export default KPIRenderer;